import {
    FETCH_PATIENT_REVIEW_REQUEST,
    FETCH_PATIENT_REVIEW_SUCCESS,
    FETCH_PATIENT_REVIEW_FAILURE,
  } from "../types/PatientReviewTypes";
  
  import { fetchPatientReviewList } from "../../services/PatientReviewService";
  import { showErrorAlert } from "../../services/ErrorHandlingService";
  
  export const fetchPatientReviewAction = () => {
    return async (dispatch) => {
      dispatch({ type: FETCH_PATIENT_REVIEW_REQUEST });
  
      try {
        const response = await fetchPatientReviewList();
  
        if (response.data?.status === "success") {
          dispatch({
            type: FETCH_PATIENT_REVIEW_SUCCESS,
            payload: response.data.data,
          });
  
          return response.data.data;
        } else {
          throw new Error(response.data?.message || "Failed to fetch reviews");
        }
      } catch (error) {
        dispatch({
          type: FETCH_PATIENT_REVIEW_FAILURE,
          payload: error.message,
        });
  
        showErrorAlert(error.message);
        throw error;
      }
    };
  };